// SEO.tsx
import React, { useEffect } from 'react';

interface SEOProps {
  title: string;
  description: string;
  keywords?: string;
  toolType?: 'blog' | 'calculator';
}

const SEO: React.FC<SEOProps> = ({
  title,
  description,
  keywords = '',
  toolType = 'blog'
}) => {
  const siteName = 'CalcBlog';
  const fullTitle = `${title} | ${siteName}`;

  useEffect(() => {
    // Update document title
    document.title = fullTitle;
    
    // Update meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', description);
    
    // Update meta keywords
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta');
      metaKeywords.setAttribute('name', 'keywords');
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute('content', keywords || `${toolType} arrticles & calculators, ${title.toLowerCase()}`);
    
    // Update OG tags
    const updateMetaTag = (property: string, content: string) => {
      let metaTag = document.querySelector(`meta[property="${property}"]`);
      if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.setAttribute('property', property);
        document.head.appendChild(metaTag);
      }
      metaTag.setAttribute('content', content);
    };
    
    updateMetaTag('og:title', fullTitle);
    updateMetaTag('og:description', description);
    updateMetaTag('og:url', window.location.href);
    
    // Cleanup on component unmount
    return () => {
      document.title = 'CalcBlog - Calculators & Insights.';
      // Reset to default meta tags if needed
    };
  }, [title, description, keywords, toolType, fullTitle]);

  return null; // This component doesn't render anything
};

export default SEO;